"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
(function ($) {
  // ECMA5 strict mode
  'use strict';

  // check namespace
  $.b2b = $.b2b || {};

  /**
   * Конструктор плагина рекомендаций
   * @param {any} container Контейнер, в котором будут размещаться рекомендации
   */
  var Recommendations = function Recommendations(container) {
    var $container = container;
    var $this = this;
    var state = {
      type: RecommendationsType.ForClient,
      template: RecommendationsTemplate.Cards,
      destination: RecommendationsDestinations.HomePage,
      currentProductIds: [],
      productRecommendationsPage: 1,
      clientRecommendationsPage: 1,
      sourceArticul: null
    };

    /**
     * Инициализировать рекомендации
     * @param {any} type Тип рекомендаций
     * @param {any} destination Страница назначения
     * @param {any} template Шаблон
     */
    this.init = function (type, destination, template, sourceArticul) {
      var refreshButton = $container.find('.refresh-button');
      var productsContainer = $container.find('.products');
      productsContainer.click(function () {
        switch ($this.recommendationsState.destination) {
          case RecommendationsDestinations.Cart:
            sendMetrik('Recommendations_Basket');
            break;
          case RecommendationsDestinations.Catalog:
            sendMetrik('Recommendations_Catalog');
            break;
          case RecommendationsDestinations.HomePage:
            sendMetrik('Recommendations_Mainpage');
            break;
          case RecommendationsDestinations.MyOrders:
            sendMetrik('Recommendations_Orders');
            break;
          case RecommendationsDestinations.ProductPage:
            sendMetrik('Recommendations_Product');
            break;
          case RecommendationsDestinations.SimilarProductPage:
            sendMetrik('Recommendations_SimilarProduct');
            break;
        }
      });
      $this.recommendationsState = _objectSpread(_objectSpread({}, state), {}, {
        type: type,
        template: template,
        destination: destination,
        sourceArticul: sourceArticul
      });
      if (refreshButton) {
        refreshButton.click(function (e) {
          var _sender = $(e.currentTarget);
          _sender.attr('disabled', true);
          _sender.find('.mdi').addClass('mdi-rotate');
          $this.loadRecommendations($this.recommendationsState.currentProductIds, true).then(function () {
            _sender.removeAttr('disabled');
            _sender.find('.mdi').removeClass('mdi-rotate');
          });
        });
      }
    };

    /**
     * Загрузить рекомендации
     * @param {any} productIds Id продуктов
     * @param {any} refresh Обновить рекомендации?
     * @returns Deffered объект
     */
    this.loadRecommendations = function (productIds, refresh) {
      $this.recommendationsState.currentProductIds = productIds;
      switch ($this.recommendationsState.type) {
        case RecommendationsType.ForClient:
          return getRecommendationsForClient($this.recommendationsState.destination, refresh).done(function (result) {
            if (!result) {
              return;
            }
            if (result.Data && result.Data.Products && result.Data.Products.length < 5) {
              $this.recommendationsState.clientRecommendationsPage = 0;
            }
            processResult(result, $this.recommendationsState.template);
          }).fail($.b2b.errors.showAjaxError);
        case RecommendationsType.ForProducts:
          return getRecommendationsForProduct($this.recommendationsState.destination, productIds, refresh).done(function (result) {
            if (!result) {
              return;
            }
            if (result.Data && result.Data.Products && result.Data.Products.length < 5) {
              $this.recommendationsState.productRecommendationsPage = 0;
            }
            processResult(result, $this.recommendationsState.template);
          }).fail($.b2b.errors.showAjaxError);
      }
    };

    /**
     * Загрузить Похожие товары
     * @param {any} articul Артикул товара
     * @returns Deffered объект
     */
    this.loadSimilarProducts = function (articul) {
      return getSimilarProductsRecommendations(encodeURIComponent(articul)).done(function (result) {
        return processResult(result, $this.recommendationsState.template);
      }).fail($.b2b.errors.showAjaxError);
    };
    var processResult = function processResult(result, template) {
      if (!result.Data || !result.Data.Products || !result.Data.Products.length) return;
      if (!result.Data.ShowMore) {
        var refreshButton = $container.find('.refresh-button');
        refreshButton.attr('disabled', true);
      }
      switch (template) {
        case RecommendationsTemplate.Carousel:
          fillCarouselContainer($container, result.Data.Products, $this.recommendationsState.destination);
          break;
        case RecommendationsTemplate.Cards:
          fillCardsContainer($container, result.Data.Products, $this.recommendationsState.destination);
          break;
      }
    };
    var fillCarouselContainer = function fillCarouselContainer(container, recommendationProducts, destination) {
      container.show();
      var carousel = getCarouselTemplate();
      container.find('.products').empty();
      container.find('.products').addClass('recommendations-carousel');
      container.find('.products').append(carousel);
      var _iterator = _createForOfIteratorHelper(recommendationProducts),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var rp = _step.value;
          var template = getRecommendationTemplate(rp.Id, rp.Name, rp.Code, rp.Articul, destination, rp.Price, rp.Currency, rp.AtStock, rp.PreviewUrl);
          carousel.slick('slickAdd', template);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };
    var fillCardsContainer = function fillCardsContainer(container, recommendationProducts, destination) {
      container.show();
      container.find('.products').empty();
      container.find('.products').addClass('cards');
      var _iterator2 = _createForOfIteratorHelper(recommendationProducts),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var rp = _step2.value;
          var template = void 0;
          template = getRecommendationTemplate(rp.Id, rp.Name, rp.Code, rp.Articul, destination, rp.Price, rp.Currency, rp.AtStock, rp.PreviewUrl);
          container.find('.products').append(template);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    };
    var getAtStockDivString = function getAtStockDivString(atStock) {
      return "<div class=\"recomendation-at-stock\">\u041D\u0430 \u0441\u043A\u043B\u0430\u0434\u0435: <span>".concat(atStock, "</span></div>");
    };
    var getPriceDivString = function getPriceDivString(price, currency) {
      return "<div class=\"recomendation-price\"><span>".concat(price, "</span> <i class=\"fa fa-").concat(currency == 1 || currency.toLowerCase() == 'usd' ? 'usd' : 'rub', "\"></i></div>");
    };
    var getRecommendationTemplate = function getRecommendationTemplate(id, name, code, articul, destination, price, priceCurrency, atStock, imageUrl) {
      var template = $("<div class=\"product-image item column card-column\" title='".concat(name, "'/>"));
      var additionalUrl = code ? '/Products/GetImage?productCode=' + code + '&getSmall=true' : '/Products/GetDefaultImage';
      var img = $("<img src=\"".concat(imageUrl, "\"/>"));
      template.append(img);
      template.append("<div class=\"articul\" title='".concat(articul, "'><h5>").concat(articul, "</h5></div>"));
      if (destination == RecommendationsDestinations.SimilarProductPage) {
        template.append("<a class=\"description\" href=\"/Products/Details?similar&".concat($this.recommendationsState.sourceArticul ? "recomendedFor=".concat(encodeURIComponent($this.recommendationsState.sourceArticul), "&") : '', "code=").concat(encodeURIComponent(code), "\" target=\"_blank\">").concat(name, "</a>"));
      } else {
        template.append("<a class=\"description\" href=\"/Products/Details?recommended&".concat($this.recommendationsState.sourceArticul ? "recomendedFor=".concat(encodeURIComponent($this.recommendationsState.sourceArticul), "&") : '', "code=").concat(encodeURIComponent(code), "\" target=\"_blank\">").concat(name, "</a>"));
      }
      template.append("".concat(price ? getPriceDivString(price, priceCurrency) : ''));
      template.append("".concat(atStock ? getAtStockDivString(atStock) : ''));
      return template;
    };
    var getCarouselTemplate = function getCarouselTemplate() {
      return $('<div class="slick"/>').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 10000,
        focusOnSelect: true,
        variableWidth: false
      });
    };

    /** Возвращает топ рекоммендаций по выбранным артикулам
     * @param {any} destination Страница назначения
     * @param {any} productIds Выбранные товары
     * @param {any} refresh Обновить рекомендации
     */
    var getRecommendationsForProduct = function getRecommendationsForProduct(destination, productIds) {
      var refresh = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (!productIds || !productIds.length) return $.Deferred().resolve(null).promise();
      $this.recommendationsState.productIds = productIds;
      if (refresh) {
        $this.recommendationsState.productRecommendationsPage++;
      }
      return $.get({
        url: "/Catalog/GetProductRecommendations?destination=".concat(destination).concat(productIds.filter(function (id) {
          return id && id > 0;
        }).map(function (productId) {
          return "&productIds=".concat(encodeURIComponent(productId));
        }).reduce(function (p, n) {
          return p + n;
        }, ''), "&page=".concat($this.recommendationsState.productRecommendationsPage))
      });
    };

    /**Возвращает топ рекоммендация для клиента
     * @param {any} destination Страница назначения
     * @param {any} refresh Обновить рекомендации
    */
    var getRecommendationsForClient = function getRecommendationsForClient(destination) {
      var refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (refresh) {
        $this.recommendationsState.clientRecommendationsPage++;
      }
      return $.get({
        url: "/Catalog/GetClientRecommendations?destination=".concat(destination, "&page=").concat($this.recommendationsState.clientRecommendationsPage)
      });
    };

    /** Возвращает информацию о похожих продуктах
     * @param {any} articul Артикул продукта
     */
    var getSimilarProductsRecommendations = function getSimilarProductsRecommendations(articul) {
      if (!articul) return null;
      $this.recommendationsState.articuls = [articul];
      return $.get({
        url: "/Catalog/GetSimilarProductsRecommendations?articul=".concat(articul)
      });
    };
    var sendMetrik = function sendMetrik(metrikAdress) {
      if (metrikAdress) Ya && Ya.reachGoal(metrikAdress);
    };
  };

  /** Рекомендации B2B */
  $.b2b.recommendations = Recommendations;
})(jQuery);

/** Типы рекомендаций */
var RecommendationsType = {
  /** Индивидуальные рекомендации */
  ForClient: 1,
  /** Совместные покупки */
  ForProducts: 2
};

/** Шаблоны рекоммендаций */
var RecommendationsTemplate = {
  /** Слайд-шоу карусель */
  Carousel: 1,
  /** Карточки */
  Cards: 2
};

/** Перечисление страниц, на которых возможны рекоммендации */
var RecommendationsDestinations = {
  /** Неизвестная страница */
  Unkown: 0,
  /** Домашняя страница */
  HomePage: 1,
  /** Каталог */
  Catalog: 2,
  /** Карточка товара */
  ProductPage: 3,
  /** Корзина */
  Cart: 4,
  /** Мои заказы */
  MyOrders: 5,
  /** Карточка Похожего товара */
  SimilarProductPage: 6
};